import React, { useState } from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { toast } from "sonner";
import api, { formatErr } from "../../lib/api";
import TurnstileField, { TS_KEY } from "../../components/TurnstileField";

export default function Contact() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [tsToken, setTsToken] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (TS_KEY && !tsToken) { toast.error("Please complete the security check."); return; }
    setBusy(true);
    try {
      await api.post("/public/contact", { ...form, turnstile_token: tsToken });
      toast.success("Thank you! Our care advisory team will reach out shortly.");
      setForm({ name: "", phone: "", email: "", message: "" });
    } catch (err) { toast.error(formatErr(err)); }
    setBusy(false);
  };
  return (
    <div className="p1-container py-14 lg:py-20" data-testid="contact-page">
      <div className="grid gap-10 lg:grid-cols-2">
        <div>
          <p className="p1-eyebrow">Contact</p>
          <h1 className="mt-3 font-heading text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl">Talk to a Care Advisor</h1>
          <p className="mt-4 text-lg text-stone-600">Questions about care for your parents? Call, write or drop in — we're happy to help you think it through, no obligation.</p>
          <div className="mt-8 space-y-4">
            {[
              { icon: Phone, t: "+91 86905 45601", s: "Mon–Sun, 8 AM – 8 PM IST", href: "tel:+918690545601" },
              { icon: Mail, t: "contact@parentonecare.com", s: "We reply within one working day", href: "mailto:contact@parentonecare.com" },
              { icon: MapPin, t: "Plot No. 36, Prithviraj Nagar, Durgapura, Jaipur, Rajasthan – 302018", s: "Visits by appointment" },
              { icon: Clock, t: "SOS escalation: always-on", s: "For subscribed families" },
            ].map((c) => (
              <div key={c.t} className="flex items-start gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-emerald-900/5 text-emerald-900"><c.icon className="h-5 w-5" /></span>
                <div><p className="font-semibold text-stone-800">{c.href ? <a href={c.href} className="hover:text-emerald-900 hover:underline" data-testid={c.t.includes("@") ? "contact-email-link" : "contact-phone-link"}>{c.t}</a> : c.t}</p><p className="text-sm text-stone-500">{c.s}</p></div>
              </div>
            ))}
          </div>
        </div>
        <form onSubmit={submit} className="p1-card p-7" data-testid="contact-form">
          <h2 className="font-heading text-xl font-bold text-stone-900">Request a callback</h2>
          <div className="mt-5 space-y-4">
            <div><label className="p1-label">Your name *</label>
              <input className="p1-input" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" /></div>
            <div><label className="p1-label">Phone *</label>
              <input className="p1-input" required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="contact-phone" /></div>
            <div><label className="p1-label">Email</label>
              <input type="email" className="p1-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" /></div>
            <div><label className="p1-label">How can we help?</label>
              <textarea className="p1-input" rows={4} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" /></div>
            <TurnstileField onToken={setTsToken} />
            <button type="submit" disabled={busy} className="p1-btn-primary w-full" data-testid="contact-submit">{busy ? "Sending…" : "Request Callback"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
